
import React from 'react';
import { Card } from "@/components/ui/card";
import { Calendar } from 'lucide-react';
import type { PerformanceData } from './types';
import { useIsMobile } from '@/hooks/use-mobile';

interface StreakTrackerProps {
  performanceData: PerformanceData[];
}

export const StreakTracker: React.FC<StreakTrackerProps> = ({ performanceData }) => {
  const { isMobile } = useIsMobile();
  
  const streakData = React.useMemo(() => {
    // Group attempts by date
    const attemptsByDate = performanceData.reduce((acc, curr) => {
      const date = new Date(curr.created_at).toISOString().split('T')[0];
      if (!acc[date]) acc[date] = 0;
      acc[date]++;
      return acc;
    }, {} as Record<string, number>);

    // Calculate current streak
    let currentStreak = 0;
    const today = new Date().toISOString().split('T')[0];
    let checkDate = today;

    while (attemptsByDate[checkDate]) {
      currentStreak++;
      const prevDate = new Date(checkDate);
      prevDate.setDate(prevDate.getDate() - 1);
      checkDate = prevDate.toISOString().split('T')[0];
    }

    return {
      currentStreak,
      attemptsByDate
    };
  }, [performanceData]);

  return (
    <Card className={isMobile ? "p-4" : "p-6"}>
      <h2 className={`${isMobile ? "text-base" : "text-xl"} font-semibold mb-3 flex items-center gap-2`}>
        <Calendar className="w-5 h-5 text-purple-500" />
        Learning Streak
      </h2>
      <div className="text-center">
        <div className={`${isMobile ? "text-3xl" : "text-4xl"} font-bold text-purple-500 mb-2`}>
          {streakData.currentStreak}
        </div>
        <div className={`${isMobile ? "text-sm" : "text-base"} text-gray-600`}>
          {streakData.currentStreak === 1 ? 'Day' : 'Days'} Streak
        </div>
      </div>
    </Card>
  );
};
